import { watch, computed, ref } from 'vue';
export function useModelValue(value, onChange, defaultValue) {
  var _value2;
  var _value = ref();
  _value.value = (_value2 = value()) !== null && _value2 !== void 0 ? _value2 : defaultValue;
  var sValue = computed({
    get: function get() {
      var _value3;
      return (_value3 = value()) !== null && _value3 !== void 0 ? _value3 : _value.value;
    },
    set: function set(val) {
      _value.value = val;
      onChange(val);
    }
  });
  watch(value, function () {
    _value.value = value();
  });
  return {
    value: sValue
  };
}